/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edit-icon[_ngcontent-%COMP%]{align-content:left}.data-block__label__override[_ngcontent-%COMP%]{text-align:right}"];
export { styles as styles };
